import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../../../colorVars';
import ApplyRounding from '../../../../../../../../../utils/math/ApplyRounding';
import { HoverBox } from '../../../hoverBox/HoverBox';
import { useWebsocketStore } from '../../../../../../../../../stores/websocketStore/websocketProvider';
import { observer } from 'mobx-react-lite';

export const CandleTrailLine = observer(({
  tradePlanId,
  priceToBreak,
  candleDuration,
  breakBy,
  size,
  scaleY,
  portalRef,
}) => {
  const { tradePlanStore } = useWebsocketStore();
  const tradePlan = tradePlanStore.tradePlans[tradePlanId] ?? null;
  const paused = tradePlan?.exitTactics['CANDLE_TRAIL']?.paused ?? null;
  const json = {
    Category: 'Exit Tactic',
    Type: 'Candle Trail',
    'Candle Duration': candleDuration,
    'Trail Price': ApplyRounding(Number(priceToBreak), 2),
    'Break By': breakBy,
  };
  return (
    <>
      {scaleY && priceToBreak > 0 && priceToBreak < 1000000 ? (
        <>
          {paused ? (
            <line
              strokeDasharray={4}
              stroke={colors.red}
              strokeWidth={2}
              x1={0}
              x2={size}
              y1={scaleY(Number(priceToBreak))}
              y2={scaleY(Number(priceToBreak))}
            />
          ) : (
            <line
              stroke={colors.red}
              strokeWidth={2}
              x1={0}
              x2={size}
              y1={scaleY(Number(priceToBreak))}
              y2={scaleY(Number(priceToBreak))}
            />
          )}

          <HoverBox
            json={json}
            topBoundary={scaleY(Number(priceToBreak)) - 2}
            bottomBoundary={scaleY(Number(priceToBreak)) + 2}
            leftBoundary={0}
            rightBoundary={size}
            portalRef={portalRef}
            size={size}
          />
        </>
      ) : null}
    </>
  );
});

CandleTrailLine.propTypes = {
  priceToBreak: PropTypes.number,
  candleDuration: PropTypes.number,
  breakBy: PropTypes.number,
  size: PropTypes.number,
  scaleY: PropTypes.func,
  portalRef: PropTypes.object,
  tradePlanId: PropTypes.any
};
